/** @jsx jsx */
import { lazy, Suspense } from 'react';
import { jsx } from '@emotion/core';

import CenteredLoader from 'components/CenteredLoader';
import {
  TCurrentGlobalViewWidgetSet,
  WidgetsType,
} from 'components/pages/Content/types';
import { WIDGETS_TYPE } from 'components/pages/Content/constants';

const WidgetAction = lazy(() => import('components/widgets/WidgetAction'));
const WidgetActionGlobalView = lazy(
  () => import('components/widgets/WidgetActionGlobalView'),
);
const WidgetActionRanking = lazy(
  () => import('components/widgets/WidgetActionRanking'),
);
const WidgetBadge = lazy(() => import('components/widgets/WidgetBadge'));
const WidgetEdito = lazy(() => import('./WidgetEdito'));
const WidgetPoints = lazy(() => import('components/widgets/WidgetPoints'));
const WidgetVideo = lazy(() => import('components/widgets/WidgetVideo'));
const WidgetGame = lazy(() => import('components/widgets/WidgetGame'));

interface TProps {
  currentGlobalViewWidgetSet?: TCurrentGlobalViewWidgetSet;
  widget: WidgetsType;
  half: boolean;
  isDisplayOnWidgetDouble?: boolean;
}

const WidgetContent = ({
  currentGlobalViewWidgetSet,
  widget,
  half,
  isDisplayOnWidgetDouble = false,
}: TProps): JSX.Element => {
  switch (widget['@type']) {
    case WIDGETS_TYPE.ACTION:
      return (
        <Suspense fallback={<CenteredLoader />}>
          <WidgetAction
            widget={widget}
            half={half}
            currentGlobalViewWidgetSet={currentGlobalViewWidgetSet}
          />
        </Suspense>
      );
    case WIDGETS_TYPE.ACTION_GLOBAL_VIEW:
      return (
        <Suspense fallback={<CenteredLoader />}>
          <WidgetActionGlobalView widget={widget} />
        </Suspense>
      );
    case WIDGETS_TYPE.ACTION_RANKING:
      return (
        <Suspense fallback={<CenteredLoader />}>
          <WidgetActionRanking widget={widget} half={half} />
        </Suspense>
      );
    case WIDGETS_TYPE.BADGE:
      return (
        <Suspense fallback={<CenteredLoader />}>
          <WidgetBadge widget={widget} half={half} />
        </Suspense>
      );
    case WIDGETS_TYPE.EDITO:
      return (
        <Suspense fallback={<CenteredLoader />}>
          <WidgetEdito
            widget={widget}
            isDisplayOnWidgetDouble={isDisplayOnWidgetDouble}
          />
        </Suspense>
      );
    case WIDGETS_TYPE.POINTS:
      return (
        <Suspense fallback={<CenteredLoader />}>
          <WidgetPoints widget={widget} half={half} />
        </Suspense>
      );
    case WIDGETS_TYPE.VIDEO:
      return (
        <Suspense fallback={<CenteredLoader />}>
          <WidgetVideo widget={widget} half={half} />
        </Suspense>
      );
    case WIDGETS_TYPE.GAME:
      return (
        <Suspense fallback={<CenteredLoader />}>
          <WidgetGame widget={widget} half={half} />
        </Suspense>
      );
    default:
      return <span />;
  }
};

WidgetContent.defaultProps = {
  half: false,
};

export default WidgetContent;
